import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AppPoint from 'components/App/AppPoint';
import Button from 'components/App/Button';
import CustomerAccountTypeBadge from 'components/App/CustomerAccountTypeBadge';

import { ReactComponent as NoItem } from 'assets/images/NoReview.svg';
import { convertIsoDateToString } from 'utils';

import styles from './ManagerReviewsDataTableList.module.scss';

const COLUMN_MIN_WIDTH = {
  reviewId: 130,
  score: 140,
  content: 570,
  date: 130,
  customer: 240,
  place: 240,
};

const getCustomerName = (item) => (
  item?.user?.fullName || item?.user?.displayName || '-'
);

const getCustomerId = (item) => item?.user?.userId || item?.user?._id || '-';

const getCustomerLevel = (item) => item?.user?.level || '';

const getPlaceName = (item) => item?.place?.name || '-';

const getMarketName = (item) => item?.place?.market?.name || '-';

const getRateLabel = (overviewReview) => {
  if (overviewReview >= 9) return 'Xuất sắc';
  if (overviewReview >= 7.5) return 'Tốt';
  if (overviewReview >= 5) return 'Ổn';
  if (overviewReview >= 2.5) return 'Tệ';
  return 'Rất tệ';
};

function ManagerReviewsDataTableList(props) {
  const { list, onOpenDetail } = props;

  return (
    <div className={styles.Component}>
      <Table responsive className="Table">
        <thead className="Table__Header">
          <tr className="Table__Header__Row">
            {/* <th
              className="Table__Header__Row__Content"
              style={{ minWidth: COLUMN_MIN_WIDTH.reviewId }}
            >
              Mã đánh giá
            </th> */}

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: COLUMN_MIN_WIDTH.place }}
            >
              Tên chỗ nghỉ | Thị trường
            </th>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: COLUMN_MIN_WIDTH.score }}
            >
              Điểm đánh giá
            </th>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: COLUMN_MIN_WIDTH.content }}
            >
              Nội dung đánh giá
            </th>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: COLUMN_MIN_WIDTH.date }}
            >
              Ngày đánh giá
            </th>

            <th
              className="Table__Header__Row__Content"
              style={{ minWidth: COLUMN_MIN_WIDTH.customer }}
            >
              Mã khách hàng | Khách hàng
            </th>

          </tr>
        </thead>

        <tbody className="Table__Body">
          {list.length > 0 ? (
            list.map((item) => (
              <tr className="Table__Body__Row" key={item._id}>
                {/* <td className="Table__Body__Row__Content">
                  <p className="ReviewId">{`#${item._id}`}</p>
                </td> */}

                <td className="Table__Body__Row__Content">
                  <p className="PlaceName">{getPlaceName(item)}</p>

                  <p className="PlaceMarket">{getMarketName(item)}</p>

                  <div className="Action">
                    <Button
                      outline
                      classes="Action__Button Action__Button__Link"
                      onClick={() => onOpenDetail(item)}
                    >
                      Xem chi tiết
                    </Button>
                  </div>
                </td>

                <td className="Table__Body__Row__Content">
                  <div className="ItemScore">
                    <AppPoint
                      point={item.overviewReview}
                      className="ItemPoint"
                    />

                    <span className="ItemScoreText">
                      {getRateLabel(item.overviewReview)}
                    </span>
                  </div>
                </td>

                <td className="Table__Body__Row__Content">
                  {item?.content && (
                    <p className="ItemSubContent">{item.content}</p>
                  )}

                  {/* <p className="ItemComment">{item?.subContent || '-'}</p> */}
                </td>

                <td className="Table__Body__Row__Content">
                  {item.createdAt
                    ? convertIsoDateToString(item.createdAt)
                    : '-'}
                </td>

                <td className="Table__Body__Row__Content">
                  <p className="CustomerId">{`#${getCustomerId(item)}`}</p>

                  <div className="CustomerRow">
                    <p className="CustomerName">{getCustomerName(item)}</p>

                    <CustomerAccountTypeBadge
                      level={getCustomerLevel(item)}
                      fallback="-"
                    />
                  </div>
                </td>

              </tr>
            ))
          ) : (
            <tr className="Table__Body__Row">
              <td
                colSpan="5"
                className="Table__Body__Row__Content text-center"
                style={{ borderBottom: 'none' }}
              >
                <div className="EmptyItem">
                  <NoItem />

                  <p>Chưa có đánh giá nào</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
}

ManagerReviewsDataTableList.propTypes = {
  list: PropTypes.instanceOf(Array),
  onOpenDetail: PropTypes.func,
};

ManagerReviewsDataTableList.defaultProps = {
  list: [],
  onOpenDetail: () => {},
};

export default React.memo(ManagerReviewsDataTableList);
